import { Component } from '@angular/core';

@Component({
  selector: 'un-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss'],
  standalone: false,
})
export class PageLoaderComponent {}
